export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة المرور"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متابعة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل كلمة مرور التأكيد"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة مرور التأكيد"])}
}